import { MATERIAL_TAG } from '../../../constants/news';
import { IMaterial } from '../../../interfaces/news';

export const getTestButtonText = (tags: IMaterial['tags']) => {
  if (tags.includes(MATERIAL_TAG.TESTS)) {
    return 'Пройти тест';
  }
  if (tags.includes(MATERIAL_TAG.GAMES)) {
    return 'Узнать';
  }

  if (tags.includes(MATERIAL_TAG.CALCS)) {
    return 'Рассчитать';
  }
};
